enum UnitScale {
  Millimeter = 1,
  Centimeter = 2,
  Meter = 3,
}

export default UnitScale;
